import type { ReactNode } from 'react';

/**
 * F-108 — EmptyState primitive.
 *
 * A consistent way to render "no data" screens. Has a title, optional
 * description, and an optional action button (or any node). Use this
 * instead of one-line `<div className="empty-state">…</div>` blocks so
 * the moderator always gets help acting from an empty surface.
 */
interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  /** Optional test id for cross-component selection. */
  testId?: string;
  /** Optional className to keep the existing site-specific styling hooks. */
  className?: string;
}

export default function EmptyState({
  title,
  description,
  action,
  testId,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={`empty-state empty-state--rich${className ? ` ${className}` : ''}`}
      role="status"
      data-testid={testId}
    >
      <div className="empty-state__title">{title}</div>
      {description && <div className="empty-state__description">{description}</div>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}
